// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const ProtectedRoute = ({ element: Component }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/admin-login" replace />;
  }

  try {
    // Decode token to check expiry
    const decoded = jwtDecode(token);
    const isExpired = decoded.exp * 1000 < Date.now();

    if (isExpired) {
      localStorage.removeItem("token");
      return <Navigate to="/admin-login" replace />;
    }

    // ✅ Token valid → show component
    return <Component />;
  } catch (err) {
    localStorage.removeItem("token");
    return <Navigate to="/admin-login" replace />;
  }
};

export default ProtectedRoute;
